<template>
  <transition :name="`imbee-${animation}`">
    <div v-if="show" :style="{ color, backgroundColor }" class="imbee-badge">
      <span>{{ text }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Badge",
  props: {
    show: { type: Boolean, default: false },
    animation: { type: String, default: "fade" },
    text: { type: Number, default: 0 },
    color: { type: String, default: "black" },
    backgroundColor: { type: String, default: "yellow" },
  },
};
</script>

<style scoped>
.imbee-badge {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 9999;
  position: absolute;
  top: -4px;
  right: 1px;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  justify-content: center;
  align-items: center;
  padding: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0px 1px 5px rgba(31, 31, 31, 0.25);
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// Badge.vue?29007872